export default {
  form: {
    first_name: {
      label: 'Fornavn',
    },
    last_name: {
      label: 'Efternavn',
    },
    email: {
      label: 'E-mail',
    },
    phone_number: {
      label: 'Telefonnummer',
    },
    birthday: {
      label: 'Fødselsdag',
    },
    city: {
      label: 'By',
    },
  },
  buttons: {
    save: 'Gem',
  },
  toasts: {
    success: 'Profilen er opdateret',
    error: 'Profilen kunne ikke opdateres',
  },
};
